import styled from 'styled-components';

const Columns = ({ children, className, gap }) => {
  return (
    <Container className={className} gap={gap}>
      {children}
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${props => props.gap || 'var(--gap)'};
`;

export default Columns;
